import { useState } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import { Control, UseFormClearErrors } from "react-hook-form";
import { IconArrowBack, IconClipboardText } from "@tabler/icons-react";
import TextareaField from "../../../components/common/TextareaField";

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: any;
  reset?: any;
};

const SectionHeader = ({
  title,
}: {
  icon?: any;
  title: string;
}) => (
  <div className="mb-2">
    <p className="text-[#212121]/80 uppercase text-xs font-bold tracking-wider">
      {title}
    </p>
  </div>
);

const ReturnToShipperModal = ({
  register,
  errors,
  setValue,
  watch,
  clearErrors,
}: Props) => {
  const [pasteData, setPasteData] = useState("");

  const handlePasteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    setPasteData(val);
    // Split by lines or commas and filter empty
    const awbs = val
      .split(/[\n,]/)
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    setValue("awbs", awbs);
  };

  return (
    <div className="w-full py-4 px-6 space-y-6 bg-transparent">
      <div className="space-y-6">
        {/* Section 1: Return Setup */}
        <div className="space-y-3">
          <SectionHeader icon={IconArrowBack} title="Return Setup" />
          <div className="flex flex-col gap-4">
            <NewSelectInput
              label="Select Pickup Type"
              name="requestType"
              value={watch("requestType") || "PICKUP"}
              clearErrors={clearErrors}
              register={register}
              error={errors?.requestType}
              validation={{ required: "Please select Pickup Type" }}
              onChange={(val) => {
                setValue("requestType", val);
              }}
              selectOptions={[
                { id: "PICKUP", value: "PICKUP", text: "PICKUP" },
                { id: "DROPOFF", value: "DROPOFF", text: "DROPOFF" },
              ]}
              className="w-full"
            />
          </div>
        </div>

        {/* Section 2: Shipments List */}
        <div className="space-y-3">
          <SectionHeader icon={IconClipboardText} title="Returned Shipments" />
          
          <div className="space-y-2">
            <label className="text-xs font-semibold text-slate-500">Paste AWB Numbers</label>
            <textarea
              className="w-full h-32 p-3 border border-slate-200 rounded-xl focus:outline-none focus:border-[#FBD037] text-sm bg-yellow-50"
              placeholder="Paste AWB numbers here (one per line or separated by commas)..."
              value={pasteData}
              onChange={handlePasteChange}
            />
            {errors?.awbs && (
              <span className="text-xs text-red-500 font-semibold block">{errors.awbs.message}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnToShipperModal;
